import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const EditSubmitIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            d='M7.99967 1.33331C4.31767 1.33331 1.33301 4.31798 1.33301 7.99998C1.33301 11.682 4.31767 14.6666 7.99967 14.6666C11.6817 14.6666 14.6663 11.682 14.6663 7.99998C14.6663 4.31798 11.6817 1.33331 7.99967 1.33331ZM6.82834 11.1286L5.88501 10.1853L3.99967 8.29998L4.94234 7.35731L6.82767 9.24265L11.071 4.99998L12.0143 5.94331L6.82834 11.1286Z'
            fill='currentColor'
        />
    </svg>
));
